import script from "./BoundariesSection.vue?vue&type=script&setup=true&lang=js"
export * from "./BoundariesSection.vue?vue&type=script&setup=true&lang=js"

import "./BoundariesSection.vue?vue&type=style&index=0&id=6c44dfce&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c44dfce"]])

export default __exports__